import {
    Button,
    Modal
} from '@mui/material';
import { Box } from '@mui/system';
import { SVGDeleted } from 'assets/svg';
import { MyTextAreaInput } from 'components/TextAera';
import { TextAreaActions } from 'components/TextAera/types';
import React, { useEffect, useRef, useState } from 'react';
import { Language } from 'shared/Language';
import './styles.scss';
const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 1
};
interface PropModalOrder {
    onHandleClose?: () => void,
    onConfirm?: any,
    show?: boolean,
    note?: string,
    setNote?: any,
    password?: string,
    setPassword?: any,
    selectedItem?: any
}
const ModalNoteComponent: React.FC<PropModalOrder> = (props) => {
    const {
        onHandleClose,
        show,
        setNote,
        note
    } = props;

    const refText = useRef<TextAreaActions>(null);
    const [value, setValue] = useState<string>(note || '');

    useEffect(() => {
        setValue(note);
    }, [note]);

    const onChange = (e: string) => {
        setValue(e || '');
    };

    return (
        <div>
            <Modal
                open={show}
                onClose={() => onHandleClose()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="add-or-edit-modal"
            >
                <Box sx={style} className="content ">
                    <div className="popup_modal">
                        <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                            {/* <div style={{fontSize: 14, fontWeight: '500', color: '#474A4C'}}>Nhập mật khẩu tài khoản của bạn</div>
                            <input required type="password" id="input_password" value={password} onChange={(event) => setPassword(event.target.value)} name="input_code" placeholder='Nhập mật khẩu' /> */}
                            <MyTextAreaInput
                                ref={refText}
                                label={'Note'}
                                placeHolder={'Enter a description...'}
                                value={note || ''}
                                onChangeText={(e) => onChange && onChange(e)}
                                labelStyles={'text-big medium color-gray  padding_20'}
                                inputStyle={'text-area'}
                            />
                        </div>
                    </div>
                    <div className="footer_popup">
                        <div className="footer-modal" style={{ borderTop: 'none' }}>
                            <Button
                                style={{ flex: 1, backgroundColor: '#B98868', textTransform: 'none' }}
                                onClick={() => {
                                    setNote(value);
                                }} variant="contained" >
                                Save
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default ModalNoteComponent;
